import { Uuid } from "../../domain/model/uuid/uuid.type";
import { IdNameViewModel } from "./id-name.viewmodel.type";

export abstract class IdNameBaseViewModel implements IdNameViewModel {
  constructor(
    readonly id: Uuid,
    readonly name: string) {
  }

  toString(): string {
    return `Id: ${this.id}, Name: ${this.name}`;
  }
}
